// Mock data for Hippo Partners website

export const contactFormSubmissions = [];

export const submitContactForm = (formData) => {
  const submission = {
    id: Date.now(),
    ...formData,
    timestamp: new Date().toISOString()
  };
  contactFormSubmissions.push(submission);
  console.log('Form submitted:', submission);
  return { success: true, message: 'Mesajınız başarıyla gönderildi!' };
};

export const services = [
  {
    id: 1,
    title: 'Stratejik İK Danışmanlığı',
    description: 'İş hedefleriyle hizalanmış, sürdürülebilir organizasyonel tasarım ve strateji oluşturma.',
    icon: 'target',
    details: [
      'Doğru kişi, doğru rol',
      'Ölçülebilir İK performansı',
      'Kontrollü büyüme ve sürdürülebilir yapı'
    ]
  },
  {
    id: 2,
    title: 'Seçme & Yerleştirme',
    description: 'Uçtan uca işe alım süreci yönetimi ve yetkinlik bazlı mülakat kurguları ile doğru yeteneğe ulaşım.',
    icon: 'users',
    details: [
      'Kısa işe alım döngüleri',
      'Daha doğru aday eşleştirme',
      'Uzun vadeli istihdam başarısı'
    ]
  },
  {
    id: 3,
    title: 'Dijital İK Dönüşümü',
    description: 'ATS, performans ve bordro süreçlerinin teknoloji ile sadeleşmesi ve sistem entegrasyonu.',
    icon: 'cpu',
    details: [
      'Operasyonel verimlilik',
      'Maliyet azaltımı',
      'Şeffaf ve standart süreçler'
    ]
  },
  {
    id: 4,
    title: 'Performans Yönetimi',
    description: 'OKR/KPI bazlı modeller ve 360 derece değerlendirme sistemleri ile şeffaf başarı ölçümü.',
    icon: 'trending-up',
    details: [
      'Şeffaf ve adil değerlendirme',
      'Hedeflerle uyumlu performans',
      'Gelişim odaklı geri bildirim kültürü'
    ]
  },
  {
    id: 5,
    title: 'Eğitim & Kariyer',
    description: 'Liderlik gelişim programları, yetenek havuzu yönetimi ve kariyer planlama.',
    icon: 'graduation-cap',
    details: [
      'Yetkinlik açıklarının kapatılması',
      'İç yetenek havuzunun güçlendirilmesi',
      'Liderlik sürekliliği'
    ]
  },
  {
    id: 6,
    title: 'Çalışan Deneyimi (EX)',
    description: 'Bağlılığı güçlendiren onboarding süreçleri ve memnuniyet analitiği.',
    icon: 'heart',
    details: [
      'Artan çalışan bağlılığı',
      'Azalan işten ayrılma oranları',
      'Güçlü işveren markası algısı'
    ]
  },
  {
    id: 7,
    title: 'Outsource İK Hizmetleri',
    description: 'Part-time İK yöneticiliği veya proje bazlı uzman desteği.',
    icon: 'briefcase',
    details: [
      'Tam zamanlı İK maliyeti olmadan uzman desteği',
      'Esnek ve ölçeklenebilir yapı',
      'Süreçlerde süreklilik ve kalite'
    ]
  },
  {
    id: 8,
    title: 'Özel Proje Paketleri',
    description: 'Start-up kurulum, ölçeklenme veya 3-6 aylık hızlı dönüşüm projeleri.',
    icon: 'package',
    details: [
      'İhtiyaca özel çözümler',
      'Kısa sürede somut çıktılar',
      'Yüksek etki - ölçülebilir sonuçlar'
    ]
  }
];

export const processSteps = [
  {
    number: '01',
    title: 'Analiz',
    description: 'Mevcut İK problemlerini ve karmaşayı netleştiriyoruz.'
  },
  {
    number: '02',
    title: 'Strateji',
    description: 'Kurumunuza özel, sürdürülebilir bir yol haritası tasarlıyoruz.'
  },
  {
    number: '03',
    title: 'Uygulama',
    description: 'Sürecin her aşamasında stratejik iş ortağı olarak yanınızdayız.'
  }
];